'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 10,
    bottom: 50,
    left: 95,
    right: 95
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 5,
    xAxisShift: 5,
    yAxisShift: 10,
    yAxisLabelShift: 65
  };
};
module.exports = Params;